import { ViewModel } from 'view_models/view_model'
import { TranscriptionHistory } from 'entities/transcription_history'

export class TranscriptionHistoryViewModel extends ViewModel<TranscriptionHistory> {
    public getPath = (): string => {
        if (!this.object.type) {
            return ''
        }
        switch (this.object.type) {
            case 'EXTRACTION':
                return 'extractions'
            case 'DNA':
                return 'dna'
        }
    }
}
